/* eslint-disable import/prefer-default-export */
export const storageKeys = {
  MINI_VARIANT: 'mini-nav',
};
